import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import baseurl from "../CrudOperations/customURl";

const DummyCheckInDMS = () => {



  const [vide, setVideo] = useState("");           



  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // const response = await sendResponse()


    if (!vide) {
        toast.error("Please select a video.");
        return;
      }
    
      const formData = new FormData();
      formData.append("videoFile", vide); // 'videoFile' must match .NET parameter

    
    const response = await fetch(`${baseurl}/geoTag/AddGeoTag`, {
        method: "POST",
        body: formData,
      });

      console.log(response);
      
  


  };

  return (
    <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
    <h2 className="text-lg font-bold mb-3">
      {"Add video"}
    </h2>
    <form onSubmit={handleFormSubmit}>



   
   

      <div className="mb-2">
        <label className="block text-gray-700">Uplaod Vide *</label>
        <input
  type="file"
  accept="video/*"
  onChange={(e) => setVideo(e.target.files[0])}
  className="border border-gray-300 p-1 w-full rounded-md"
  required
/>

      </div>

      
      

     
    
    

    
    

   
   

    
    
    
    

      <div className="flex justify-end">
       

        <button
          type="submit"
          className="bg-blue-600 text-white px-3 py-1 rounded-md"
        >
          {"Submit"}
        </button>
      </div>
    </form>
  </div>
  );
};

export default DummyCheckInDMS;
